/**
 * Stats Ticker - Infinite scroll animation
 * Duplicates content to create seamless loop
 */

class StatsTickerSection {
  constructor(section) {
    this.section = section;
    this.content = section.querySelector('[data-ticker-content]');
    
    if (!this.content) return;
    
    this.init();
  }

  init() {
    // Clone content 2 times for longer seamless loop (total 3 copies)
    const items = Array.from(this.content.children);
    
    // Create 2 additional copies
    for (let i = 0; i < 2; i++) {
      items.forEach(item => {
        const clone = item.cloneNode(true);
        this.content.appendChild(clone);
      });
    }
    
    // Adjust animation duration based on content width
    this.adjustSpeed();
    
    // Re-adjust on window resize
    window.addEventListener('resize', () => this.adjustSpeed());
  }

  adjustSpeed() {
    const contentWidth = this.content.scrollWidth;
    // Base speed: 30s for ~2000px, scale proportionally (with 3 copies)
    const duration = Math.max(30, (contentWidth / 3000) * 30);
    this.content.style.animationDuration = `${duration}s`;
  }
}

// Initialize all ticker sections
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.at-stats-ticker');
  sections.forEach(section => new StatsTickerSection(section));
});

// Re-init on Shopify section re-render (theme editor)
if (Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.at-stats-ticker');
    if (section) {
      new StatsTickerSection(section);
    }
  });
}
